import React from 'react';
import ClauseProfileRow from './ClauseProfileRow';
import Selectors from '../hooks/selectors';

const ClauseProfileRows = ({
  category,
  code,
  queryUUID,
  clauseUUID,
}) => {
  const { entities } = Selectors.useClauseProfileRows({
    category, code, queryUUID, clauseUUID,
  });
  return (
    entities.map((item, index) => (
      <ClauseProfileRow
        key={`clause_profile_table_row_${item.field.label}`}
        total={item.total_value}
        count={item.count}
        label={item.field.label}
        first={index === 0}
      />
    ))
  );
};

export default ClauseProfileRows;
